import React, { useState, useEffect } from "react";
import axios from "./axios";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import { IoAlertCircleOutline } from "react-icons/io5";
import Cookie from "js-cookie";

const Login = () => {
  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });

  const [errors, setErrors] = useState({
    email: "",
    password: "",
  });

  const [errorMsg, setErrorMsg] = useState("");
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    setIsLoading(true);
    const timeoutId = setTimeout(() => {
      setIsLoading(false);
    }, 1500);
    return () => clearTimeout(timeoutId);
  }, []);

  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    setErrors({ ...errors, [e.target.name]: "" });
  };

  const validateForm = () => {
    let isValid = true;
    const newErrors = {};

    Object.entries(formData).forEach(([key, value]) => {
      if (value.trim() === "") {
        newErrors[key] = "Este campo no puede quedar vacío";
        isValid = false;
      }
    });

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!formData.email.trim() || !emailRegex.test(formData.email)) {
      newErrors.email = "Ingrese un correo electrónico válido";
      isValid = false;
    }

    if (formData.password.length < 6) {
      newErrors.password = "La contraseña debe tener al menos 6 caracteres";
      isValid = false;
    }
    setErrors(newErrors);
    return isValid;
  };

  const apiUrl = process.env.REACT_APP_API_BASE_URL;

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) {
      return;
    } else {
      try {
        const res = await axios.post(`${apiUrl}/users/login`, formData, {
          headers: { "Content-Type": "application/json" },
          // withCredentials: true,
        });
        if (res.data.token) {
          Cookie.set("token", res.data.token, { expires: 1 });
          navigate("/");
          window.location.reload();
        } else {
          setErrorMsg('Error de conexión');
        }
      } catch (error) {
        if(error.response !== undefined){
          setErrorMsg(error.response.data.error);
        } else {
          setErrorMsg('Error de conexión');
        }
      }
    }
  };

  const authToken = Cookie.get("token");
  const isLoggedIn = !!authToken;

  if (isLoggedIn) {
    return (
      <div className="loadership loadership-b">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    );
  }

  return (
    <>
      {isLoading && (
        <div className="overlay">
          <div className="parent loadership loader-front">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>
      )}
      <form className="form" onSubmit={handleSubmit}>
        <label>
          Email:
          <input
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
          />
        </label>
        {errors.email && (
          <p className="error-message">
            {" "}
            <IoAlertCircleOutline /> {errors.email}
          </p>
        )}
        <label>
          Contraseña:
          <input
            type="password"
            name="password"
            value={formData.password}
            onChange={handleChange}
          />
        </label>
        {errors.password && (
          <p className="error-message">
            {" "}
            <IoAlertCircleOutline /> {errors.password}
          </p>
        )}
        {errorMsg && (
          <p className="error-message ">
            {" "}
            <IoAlertCircleOutline /> {errorMsg}
          </p>
        )}
        <button className="button button-info login" type="submit">
          Acceder
        </button>
      </form>
      <p className="desc">
        ¿No tenés usuario? <Link to="/registrarse">¡Registrate!</Link>
      </p>
      <div className="button-container">
        <Link to="/proyecto" className="button button-secondary">
          Sobre el proyecto
        </Link>
      </div>
    </>
  );
};

export default Login;
